<template>
  <div class="loading" v-if="show_loading">
    <div class="loading-wrap" v-if="currentTheme === 'dark'">
      <img class="loading-gif" src="@/assets/loading_dark.gif" />
      <div class="text">{{ text }}</div>
    </div>
    <div class="loading-wrap" v-else>
      <img class="loading-gif" src="@/assets/loading.gif" />
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    loading: Boolean,
    text: String,
  },
  data() {
    return {
      show_loading: false,
    };
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    loading(val) {
      setTimeout(() => {
        this.show_loading = val;
      }, 600);
    },
  },
};
</script>

<style scoped lang="less">
.loading {
  // position: absolute;
  // width: 100%;
  // height: 100%;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  .loading-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 40%;
    height: 50%;
    margin: auto;
    color: var(--chart_title);
    font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
    background-color: var(--dialog_header_bgc);
    .loading-gif {
      /* position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0; */
      margin: auto;
    }
    .text {
      position: absolute;
      left: 0;
      right: 0;
      // top: 0;
      bottom: 10%;
      width: 100%;
      text-align: center;
      margin: auto;
    }
  }
}
</style>
